import React, { Component } from 'react';
import Helmet from 'react-helmet';
import PricingColumn from '../../../components/pricingcolumn/PricingColumn';
import PricingColumnEntry from '../../../components/pricingcolumnentry/PricingColumnEntry';

import './pricing.scss';

class BuyPage extends Component {
    render() {
        return (
            <div className='pricing-container'>
                <Helmet title={`Datasert - Realfire Pricing`} />

                <div className='content'>
                    <h2>
                        Realfire Pricing
                    </h2>

                    <h4 className="try-string">
                        Try Realfire Enterprise with all Features for 60 days
                    </h4>
                    <h4 className="try-string2">
                        No Credit Card Required
                    </h4>
                    <h4>
                        <a className="btn btn-outline-primary my-2 my-sm-0 btn-sm" href="/products/realfire">Download Now</a>
                    </h4>

                    <section className="pricing-style-2 bg-white p-3">
                        <div className="container">
                            <div className="row">
                                <PricingColumn name="Free">
                                    <PricingColumnEntry name="Many features with limits" />
                                    <PricingColumnEntry name="Single Salesforce Connection" />
                                    <PricingColumnEntry name="Login using OAuth or Credentials" />
                                    <PricingColumnEntry name="Secure tokens/credentials with Master password" />
                                    <PricingColumnEntry name="View Org Limits and Usage" />
                                    <PricingColumnEntry name="View Objects List" />
                                    <PricingColumnEntry name="View Object Details" />
                                    <PricingColumnEntry name="Browse Object Data" />
                                    <PricingColumnEntry name="Query Editor with support for Soql/Sosl" />
                                    <PricingColumnEntry name="Build Soqls easily with powerful Soql builder" />
                                    <PricingColumnEntry name="Run multiple Soql/Sosl Statements at a time" />
                                    <PricingColumnEntry name="View Soql results in high performance Datagrid" />
                                    <PricingColumnEntry name="Fetch More batches" />
                                    <PricingColumnEntry name="Export Datagrid as Csv" />
                                    <PricingColumnEntry name="Apex Editor for Anonymous Apex" />
                                    <PricingColumnEntry name="Rest Apis Explorer" />
                                    <PricingColumnEntry name="View CSV files in high performance CSV viewer" />
                                    <PricingColumnEntry name="Standard Object/Field Documentation" />
                                    <PricingColumnEntry name="Search for Objects" />
                                </PricingColumn>

                                <PricingColumn name="Essential" cost={11} per="per seat per month (billed annually)" buyUrl="/products/realfire/buy?edition=essential">
                                    <PricingColumnEntry name="All features in Free Edition with higher limits plus:" />
                                    <PricingColumnEntry name="Soql Wildcard Fields" />
                                    <PricingColumnEntry name="Query Variables" new/>
                                    <PricingColumnEntry name="Async Soqls" new/>
                                    <PricingColumnEntry name="Schema Report" new/>
                                    <PricingColumnEntry name="View Listview Records/Soql" />
                                    <PricingColumnEntry name="Object/Fields Summary Report" />
                                    <PricingColumnEntry name="Fields List Report" />
                                    <PricingColumnEntry name="Picklist Values Report" />
                                    <PricingColumnEntry name="File Upload Manifest Generator" />
                                    <PricingColumnEntry name="View Record Count of multiple objects" />
                                    <PricingColumnEntry name="Connection Colors" />
                                    <PricingColumnEntry name="Read-only Connections" />
                                    <PricingColumnEntry name="Ingrid Data editing" />
                                    <PricingColumnEntry name="View Soql Results in Form View"/>
                                    <PricingColumnEntry name="Export results into Excel" new/>
                                    <PricingColumnEntry name="Edit Custom Metadata Records" />
                                    <PricingColumnEntry name="View Record Hierarchy" />
                                    <PricingColumnEntry name="Create/Edit CSV Files" />
                                    <PricingColumnEntry name="Execution History" />
                                    <PricingColumnEntry name="Saved Scripts" />
                                    <PricingColumnEntry name="Recent Files" />
                                    <PricingColumnEntry name="Favorites" />
                                    <PricingColumnEntry name="Search for Fields" />
                                    <PricingColumnEntry name="Easy Notes/Attachment Management"/>
                                    <PricingColumnEntry name="View Record History"/>
                                    <PricingColumnEntry name="Explore and Query Tooling Objects"/>
                                    <PricingColumnEntry name="Filter Records/Fields in Soql Datagrid"/>
                                    <PricingColumnEntry name="Object Global Search" />
                                    <PricingColumnEntry name="Object/Field enrichment with Metadata Fields"/>
                                    <PricingColumnEntry name="Field values Preview" />
                                    <PricingColumnEntry name="View Object Limits" />
                                    <PricingColumnEntry name="Recent Objects View"/>
                                    <PricingColumnEntry name="Favorites View"/>
                                    <PricingColumnEntry name="Grid Filters" />
                                    <PricingColumnEntry name="Fields List Report" />
                                    <PricingColumnEntry name="Email Support" />
                                </PricingColumn>

                                <PricingColumn name="Professional" cost={42} per="per seat per month (billed annually)" buyUrl="/products/realfire/buy?edition=professional">
                                    <PricingColumnEntry name="All features in Essential Edition with higher limits plus:" />
                                    <PricingColumnEntry name="Export results into Google Sheets" new/>
                                    <PricingColumnEntry name="View/Search Metadata"/>
                                    <PricingColumnEntry name="Compare Metadata"/>
                                    <PricingColumnEntry name="Package XML Editor"/>
                                    <PricingColumnEntry name="Fake Data Generation" />
                                    <PricingColumnEntry name="Debug Log Management and Viewer"/>
                                    <PricingColumnEntry name="Debug Logs Streaming"/>
                                    <PricingColumnEntry name="Bulk Schema Management" />
                                    <PricingColumnEntry name="Multi Connection Org Limits Report" />
                                    <PricingColumnEntry name="Multi Object Limits Report" />
                                    <PricingColumnEntry name="Parent/Child Browser" new />
                                    <PricingColumnEntry name="Compare Data" new />
                                    <PricingColumnEntry name="Metadata DB"/>
                                    <PricingColumnEntry name="Org Limits Report"/>
                                    <PricingColumnEntry name="Objects Limits Report"/>
                                    <PricingColumnEntry name="Apex Looper" new/>
                                    <PricingColumnEntry name="View Metadata Dependency" new/>
                                    <PricingColumnEntry name="Backup and Restore of Realfire Configuration" />

                                </PricingColumn>

                                <PricingColumn name="Enterprise" cost={84} per="per seat per month (billed annually)" buyUrl="/products/realfire/buy?edition=enterprise">
                                    <PricingColumnEntry name="All features in Professional Edition with higher limits plus:" />
                                    <PricingColumnEntry name="Metadata Deployments" new/>
                                    <PricingColumnEntry name="Realfire Dataloader" />
                                    <PricingColumnEntry name="DML Executions" />
                                    <PricingColumnEntry name="Mass Schema Updates"/>
                                    <PricingColumnEntry name="Field Analysis"/>
                                    <PricingColumnEntry name="Compare Profile/Permsets" new/>
                                    <PricingColumnEntry name="Mass Assigner Assigner"/>
                                    <PricingColumnEntry name="Actions Toggler"/>
                                    <PricingColumnEntry name="List Views Management"/>
                                    <PricingColumnEntry name="Roles Viewer"/>
                                    <PricingColumnEntry name="User Management"/>
                                    <PricingColumnEntry name="Compare Users"/>
                                    <PricingColumnEntry name="View Reporting Hierarchy"/>
                                    <PricingColumnEntry name="Import Users with Profile/Role/Manager Id resolution"/>
                                    <PricingColumnEntry name="View Setup Audit History"/>
                                    <PricingColumnEntry name="View Email Log"/>
                                    <PricingColumnEntry name="View Login History"/>
                                    <PricingColumnEntry name="Page Layout Usage"/>
                                    <PricingColumnEntry name="Scheduled Jobs" new/>
                                </PricingColumn>
                            </div>
                        </div>
                    </section>            
                </div>
            </div>
        );
    }
}

export default BuyPage;


// WEBPACK FOOTER //
// ./src/pages/products/realfire/pricing.jsx